import { apiService } from "@/common/api.service.js";

export default {
  // Dashboard details
  nestedSitesAndDashboardDetails() {
    const endpoint = `/api/nested-site-dashboard-details/`;
    return apiService(endpoint);
  },

  // Company / sites
  companySites(company) {
    const endpoint = `/api/company-sites/${company}/`;
    return apiService(endpoint);
  },

  companies() {
    const endpoint = `/api/companies/`;
    return apiService(endpoint);
  },

  // Currencies
  currencies() {
    const endpoint = `/api/currencies/`;
    return apiService(endpoint);
  },

  // Site services
  siteServices(payload) {
    const endpoint = `/api/site-service-list/${payload.site_code}/`;
    return apiService(endpoint);
  },

  updateSiteServices(payload) {
    const endpoint = `/api/site-service-list/${payload.site_code}/`;
    return apiService(endpoint, "POST", payload);
  },

  // Site / company names
  siteNames() {
    const endpoint = `/api/site-names/`;
    return apiService(endpoint);
  },

  siteCompanyNames() {
    const endpoint = `/api/site-company-names/`;
    return apiService(endpoint);
  },

  // PDF report permissions (permitted sites)
  permittedSites() {
    const endpoint = `/documents/pdf-report-create/`;
    return apiService(endpoint);
  },

  // Sites & SEU
  sitesAndSeu() {
    const endpoint = `/api/sites-and-seu/`;
    return apiService(endpoint);
  },

  sitesAndSeuAndOpp() {
    const endpoint = `/api/sites-and-seu-and-opp/`;
    return apiService(endpoint);
  },

  opportunitiesSites() {
    const endpoint = `/api/opportunities-sites/`;
    return apiService(endpoint);
  },

  // Nested site structures
  nestedCompanySites() {
    const endpoint = `/api/nested-company-sites/`;
    return apiService(endpoint);
  },

  nestedSitesAndSeu() {
    const endpoint = `/api/nested-site-seu/`;
    return apiService(endpoint);
  },

  serviceSitesAndSeu() {
    const endpoint = `/api/service-site-seu/`;
    return apiService(endpoint);
  },

  // Site SEU list
  siteSeuList(id) {
    const endpoint = `/api/site-seu/${id}/`;
    return apiService(endpoint);
  },

  // Action / event metadata
  actionTypes() {
    const endpoint = `/api/action-types/`;
    return apiService(endpoint);
  },

  eventTypes() {
    const endpoint = `/api/event-types/`;
    return apiService(endpoint);
  },

  costIntervals() {
    const endpoint = `/api/cost-intervals/`;
    return apiService(endpoint);
  },

  opportunityStatusList() {
    const endpoint = `/api/opportunity-status-list/`;
    return apiService(endpoint);
  },

  // Plans
  plansCompanies() {
    const endpoint = `/api/plans-companies/`;
    return apiService(endpoint);
  },

  plansSites() {
    const endpoint = `/api/plans-sites/`;
    return apiService(endpoint);
  },
};
